/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Templates_EmptyInputs */



/**
* | output |
* | --- |
* | "No conversation types yet." |
*
* @param {Settings_Templates_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_empty = /** @type {((inputs?: Settings_Templates_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen gesprekstypes.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de modèles.")
	return /** @type {LocalizedString} */ ("No conversation types yet.")
});